import { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import Swal from "sweetalert2";
import { apiUrl } from '../../../config/config';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
    },
});

const initialFormState = {
    name: '',
    startDate: '',
    endDate: '',
    minimumBalance: '',
    maximumBalance: '',
    prizes: [{ descriptionPrize: '', position: '1' }],
    image: null
}

function TournamentDetailModal({ tournamentSelected, show, onClose, fetchTournaments }) {
    const [tournament, setTournament] = useState(initialFormState);
    const [countParticipants, setCountParticipants] = useState(0);
    const [isEditing, setIsEditing] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);

    const [description, setDescription] = useState('');

    useEffect(() => {
        if (tournamentSelected) {
            const { id, nameTournament, descriptionTournament, startDate, endDate, prizes, image, participants, startBalance, endBalance, initilized } = tournamentSelected;
            setTournament({
                id: id,
                name: nameTournament,
                startDate: startDate ? new Date(startDate).toISOString().split('T')[0] : '',
                endDate: endDate ? new Date(endDate).toISOString().split('T')[0] : '',
                minimumBalance: startBalance,
                maximumBalance: endBalance,
                initilized: !initilized ? 'No iniciado' : initilized,
                prizes: prizes ? prizes : [{ descriptionPrize: '', position: '1' }],
                image: image ? image : null,
            });
            setDescription(descriptionTournament);
            if (image) {
                setPreviewImage(image);
            } else {
                setPreviewImage(null);
            }
            setCountParticipants(participants ? participants : 0);
            setIsEditing(true)
        } else {
            setTournament(initialFormState);
            setDescription('');
            setPreviewImage(null);
            setIsEditing(false);
        }
    }, [tournamentSelected]);

    const userId = JSON.parse(window.localStorage.getItem("userProfile")).id;

    const handlePrizeChange = (index, field, value) => {
        const updatedPrizes = [...tournament.prizes];
        updatedPrizes[index][field] = value;
        setTournament({ ...tournament, prizes: updatedPrizes });
    };

    const addPrize = () => {
        const nextPosition = tournament.prizes.length + 1;
        setTournament({
            ...tournament,
            prizes: [...tournament.prizes, { descriptionPrize: '', position: `${nextPosition}` }]
        });
    };

    const removePrize = (index) => {
        const updatedPrizes = tournament.prizes.filter((_, i) => i !== index);
        setTournament({ ...tournament, prizes: updatedPrizes });
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setTournament((prev) => ({ ...prev, image: file }));
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewImage(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('nameTournament', tournament.name);
        formData.append('descriptionTournament', description);
        formData.append('startDate', tournament.startDate);
        formData.append('endDate', tournament.endDate);
        formData.append('minimumBalance', tournament.minimumBalance);
        formData.append('maximumBalance', tournament.maximumBalance);
        formData.append('user', userId);
        formData.append('prizes', JSON.stringify(tournament.prizes));
        if (tournament.image) {
            formData.append('image', tournament.image);
        }
        try {
            const response = isEditing ? await fetch(`${apiUrl}/tournaments/${tournament.id}`, {
                method: 'PATCH',
                body: formData,
            }) : await fetch(`${apiUrl}/tournaments`, {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                const errorData = await response.json();
                Toast.fire({
                    icon: "error",
                    title: (errorData.message || `No se pudo ${isEditing ? 'actualizar' : 'agregar'} el torneo`),
                    background: "#1e2836",
                });
                return;
            }
            await fetchTournaments();
            Toast.fire({
                icon: "success",
                title: `Torneo ${isEditing ? 'actualizado' : 'agregado'} con éxito`,
                background: "#1e2836",
                color: "#fff",
            });
            onCloseLocal();
        } catch (error) {
            console.error('Error al enviar el formulario:', error);
            Toast.fire({
                icon: "error",
                title: `Error al ${isEditing ? 'actualizar' : 'agregar'} el torneo`,
                background: "#1e2836",
            });
        }
    };


    const onCloseLocal = () => {
        setTournament(initialFormState)
        setDescription('')
        setPreviewImage(null)
        onClose();
    }

    return (
        <Modal show={show} onHide={onCloseLocal} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Agregar Torneo</Modal.Title>
                {isEditing &&
                    <Modal.Body>Participantes: {countParticipants}</Modal.Body>
                }
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit} encType="multipart/form-data">
                    <Form.Group>
                        <Form.Label>Nombre del torneo</Form.Label>
                        <Form.Control
                            type="text"
                            value={tournament.name}
                            onChange={(e) => setTournament({ ...tournament, name: e.target.value })}
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mt-3">
                        <Form.Label>Descripción</Form.Label>
                        {/*<Form.Control
                            as="textarea"
                            value={tournament.description}
                            onChange={(e) => setTournament({ ...tournament, description: e.target.value })}
                            required
                        />*/}
                        <ReactQuill
                            theme="snow"
                            value={description}
                            onChange={setDescription}
                            style={{ height: '100px' }}
                        />
                    </Form.Group>

                    <Form.Group className="mt-5">
                        <Form.Label>Fecha de inicio</Form.Label>
                        <Form.Control
                            type="date"
                            value={tournament.startDate}
                            onChange={(e) => setTournament({ ...tournament, startDate: e.target.value })}
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mt-3">
                        <Form.Label>Fecha de finalización</Form.Label>
                        <Form.Control
                            type="date"
                            value={tournament.endDate}
                            onChange={(e) => setTournament({ ...tournament, endDate: e.target.value })}
                            required
                        />
                    </Form.Group>

                    <div className="mt-3">
                        <div className="row g-3">
                            <div className="col-12 col-md-6">
                                <Form.Group>
                                    <Form.Label>Balance mínimo</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Ingrese balance mínimo"
                                        value={tournament.minimumBalance || ""}
                                        onChange={(e) =>
                                            setTournament({
                                                ...tournament,
                                                minimumBalance: e.target.value,
                                            })
                                        }
                                        min="0"
                                        required
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-12 col-md-6">
                                <Form.Group>
                                    <Form.Label>Balance máximo</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Ingrese balance máximo"
                                        value={tournament.maximumBalance || ""}
                                        onChange={(e) =>
                                            setTournament({
                                                ...tournament,
                                                maximumBalance: e.target.value,
                                            })
                                        }
                                        min="0"
                                        required
                                    />
                                </Form.Group>
                            </div>
                        </div>
                    </div>

                    <Form.Group className="mt-3">
                        <Form.Label>Imagen (opcional)</Form.Label>

                        {previewImage && (
                            <div style={{ marginBottom: '10px' }}>
                                <img
                                    src={previewImage}
                                    alt="Vista previa"
                                    style={{ width: '150px', borderRadius: '8px' }}
                                />
                            </div>
                        )}

                        <Form.Control
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                        />
                    </Form.Group>

                    <hr />
                    <h5>Premios</h5>
                    {tournament.prizes.map((prize, index) => (
                        <div key={index} className="d-flex gap-2 align-items-center mb-2">
                            <Form.Control
                                placeholder="Descripción del premio"
                                value={prize.descriptionPrize}
                                onChange={(e) => handlePrizeChange(index, 'descriptionPrize', e.target.value)}
                                required
                            />
                            <Form.Control
                                placeholder="Posición"
                                type="number"
                                value={prize.position}
                                disabled
                                onChange={(e) => handlePrizeChange(index, 'position', e.target.value)}
                                required
                                style={{ width: '80px', textAlign: 'right' }}
                            />
                            {index === 0 &&
                                <Button variant="danger" style={{ visibility: 'hidden' }}>
                                    X
                                </Button>
                            }
                            {index > 0 && (
                                <Button variant="danger" onClick={() => removePrize(index)}>
                                    X
                                </Button>
                            )}
                        </div>
                    ))}
                    <Button variant="secondary" onClick={addPrize}>
                        + Agregar premio
                    </Button>

                    <div className="mt-4 text-end">
                        <Button variant="primary" type="submit">{isEditing ? 'Actualizar' : 'Guardar'}</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

export default TournamentDetailModal;
